import { defineComponent as _defineComponent } from 'vue'
import ProgressWizard, { Step } from '@/components/molecules/progresswizard/ProgressWizard.vue';

interface StepperProps {
    step: 1 | 2 | 3;
    path?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRequestStepper',
  props: {
    step: null,
    path: null
  },
  setup(__props: any) {

const props = __props as {
    step: 1 | 2 | 3;
    path?: string;
};



const getStatus = (stepNumber: number): 'completed' | 'in-progress' | 'pending' => {
    if (props.step > stepNumber) return 'completed';
    if (props.step === stepNumber) return 'in-progress';
    return 'pending';
};

const createStep = (label: string, stepNumber: number, path: string = "", isClickeable: boolean | null = null): Step => ({
    label,
    status: getStatus(stepNumber),
    href: props.path || `/requests/new/${path}`,
    isClickable: isClickeable
});

const steps: Step[] = [
    createStep('Seleccionar ramo', 1, '', props.step > 1),
    createStep('Seleccionar vigencia', 2, 'conditions', props.step > 2),
    createStep('Datos', 3, 'data', props.step > 3),
    createStep('Detalle', 4, 'incendios'),
];


return { __sfc: true,props, getStatus, createStep, steps, ProgressWizard }
}

})